import { Button, SxProps, Tooltip, useTheme } from "@mui/material";
import { Control, Controller, Path } from "react-hook-form";

import { TaskFormType } from "./types";

export const TaskFormButton = ({
  icon,
  label,
  onClick,
  sx,
  control,
  name,
  tooltipTitle,
  ariaLabel,
}: {
  icon: React.ReactNode;
  label: React.ReactNode;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  sx?: SxProps;
  control: Control<TaskFormType>;
  name: Path<TaskFormType>;
  tooltipTitle?: string;
  ariaLabel?: string;
}) => {
  const theme = useTheme();
  const title = tooltipTitle ?? (typeof label === "string" ? label : "");

  return (
    <Controller
      name={name}
      control={control}
      render={({ fieldState: { error } }) => (
        <Tooltip title={title} arrow>
          <Button
            startIcon={icon}
            onClick={(e) => onClick(e)}
            variant="outlined"
            aria-label={ariaLabel ?? title}
            sx={{
              textTransform: "none",
              color: theme.palette.text.secondary,
              borderColor: error ? theme.palette.error.main : theme.palette.divider,
              fontWeight: 400,
              ...sx,
            }}
          >
            {label}
          </Button>
        </Tooltip>
      )}
    />
  );
};
